"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderLocationVehicleTypePriceFee = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const VehicleTypePriceFee_1 = require("./VehicleTypePriceFee");
let OrderLocationVehicleTypePriceFee = class OrderLocationVehicleTypePriceFee extends VehicleTypePriceFee_1.VehicleTypePriceFee {
    driverWaitingPrice = 0;
    driverWaitingFee = 0;
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
};
exports.OrderLocationVehicleTypePriceFee = OrderLocationVehicleTypePriceFee;
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Float),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderLocationVehicleTypePriceFee.prototype, "driverWaitingPrice", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Float),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], OrderLocationVehicleTypePriceFee.prototype, "driverWaitingFee", void 0);
exports.OrderLocationVehicleTypePriceFee = OrderLocationVehicleTypePriceFee = __decorate([
    (0, type_graphql_1.ObjectType)("OrderLocationVehicleTypePriceFee"),
    (0, type_graphql_1.InputType)("OrderLocationVehicleTypePriceFeeInput"),
    (0, class_transformer_1.Exclude)(),
    __metadata("design:paramtypes", [Object])
], OrderLocationVehicleTypePriceFee);
//# sourceMappingURL=OrderLocationVehicleTypePriceFee.js.map